module.exports = "/_next/static/images/lend-borrow-swap-43580a585015795deb2bc4f34943861e.png";